import { render, staticRenderFns } from "./UploadLogo.vue?vue&type=template&id=1d8a9421&"
import script from "./UploadLogo.vue?vue&type=script&lang=js&"
export * from "./UploadLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports